export * from './entidades-financieras.component';
export * from './new-entidad-dialog';



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/abm/entidades-financieras/index.ts